import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EntityManager, IEntity } from '@dch/entity-manager';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators';
import { ODB_USAGE_LEVEL_4_ENTITY } from 'src/app/my-bill/config/my-bill-entity.config';
import {
  getOdbUsageLevel4Request,
  getOdbUsageLevel4Success,
  getOdbUsageLevel4Failure,
} from '../actions';
import { ApplicationState } from '../reducers';
import { selectCustomerAccount } from '../selectors/customer-account.selector';
import { IOdbUsageLevel4Response } from 'src/app/my-bill/models/odb-usage-level-4.model';
import { CustomerAccount } from '@dch/common-business-logic';

@Injectable()
export class OdbUsageLevel4Effects {
  getOdbUsageLevel4$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getOdbUsageLevel4Request),
      withLatestFrom(this.store.select(selectCustomerAccount)),
      mergeMap(
        ([
          {
            documentReference,
            billableIdentifierNumber,
            sectionOrItemIdentifier,
            paNumber,
          },
          customerAccount,
        ]) =>
          EntityManager.getEntity<IOdbUsageLevel4Response>(
            this.getEntityConfigWithParamsInUrl(
              ODB_USAGE_LEVEL_4_ENTITY,
              customerAccount,
              paNumber
            ),
            {
              cdbId: customerAccount?.getSelectedCustomer()?.customerId,
              reference: documentReference,
              billableGroupIdentifier: billableIdentifierNumber,
            }
          ).pipe(
            map((entity) =>
              entity.value
                ? getOdbUsageLevel4Success({
                    documentReference,
                    sectionOrItemIdentifier,
                    payload: entity.value,
                  })
                : getOdbUsageLevel4Failure({
                    documentReference,
                    sectionOrItemIdentifier,
                  })
            ),
            catchError((error) => {
              return of(
                getOdbUsageLevel4Failure({
                  documentReference,
                  sectionOrItemIdentifier,
                  code: error?.errorData?.code,
                })
              );
            })
          )
      )
    )
  );

  getEntityConfigWithParamsInUrl(
    entity: IEntity<IOdbUsageLevel4Response>,
    customerAccount: CustomerAccount,
    paNumber: string
  ): IEntity<IOdbUsageLevel4Response> {
    let newEntity = { ...entity };
    if (customerAccount.isRES()) {
      newEntity.url += '&paNumber=' + paNumber;
    }
    return newEntity;
  }

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>
  ) {}
}
